import { useTranslation } from "react-i18next";
// components
import { useSettingsContext } from "../components/settings";
//
import { allLangs, defaultLang } from "./config";
import { useCallback } from "react";
import { nl, enUS, fr, es, de, ru } from "date-fns/locale";

const dateFnsLocaleMap = {
  en: enUS,
  nl: nl,
  fr: fr,
  es: es,
  de: de,
  ru: ru,
};

export default function useLocales() {
  const { i18n, t: translate } = useTranslation();
  const { onChangeDirectionByLang } = useSettingsContext();

  const currentLang =
    allLangs.find((_lang) => _lang.value === i18n.language) || defaultLang;

  const handleChangeLanguage = useCallback(
    (newlang) => {
      i18n.changeLanguage(newlang);
      onChangeDirectionByLang(newlang);
    },
    [i18n, onChangeDirectionByLang]
  );

  return {
    onChangeLang: handleChangeLanguage,
    translate: (text, options) => translate(text, options),
    currentLang,
    allLangs,
    currentDateFnsLocale: dateFnsLocaleMap[currentLang.value] || enUS,
  };
}
